import React from "react";

function Header() {
  return (
    <header>
      <h1>Keep Notes</h1>
    </header>
  );
}

export default Header;
